import { render, staticRenderFns } from "./ContactPage.vue?vue&type=template&id=71882a1b&scoped=true"
import script from "./ContactPage.vue?vue&type=script&lang=js"
export * from "./ContactPage.vue?vue&type=script&lang=js"
import style0 from "./ContactPage.vue?vue&type=style&index=0&id=71882a1b&prod&scoped=true&lang=css"
import style1 from "./ContactPage.vue?vue&type=style&index=1&id=71882a1b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71882a1b",
  null
  
)

export default component.exports